import "@stimulus/polyfills";
import { Application } from "stimulus";

const application = Application.start();

export default function () {
  let titles = document.querySelectorAll(".title h2");
  for (let i = 0; i < titles.length; i++) {
    const element = titles[i];
    let text = element.textContent;

    if (text) {
      if (text.includes("%")) {
        var t = 0;

        text = text.replace(/%/g, function (match) {
          t++;
          return t === 2 ? "</strong>" : match;
        });

        t = 0;
        text = text.replace(/%/g, function (match) {
          t++;
          return t === 1 ? "<strong>" : match;
        });

        element.innerHTML = text;
      }
    }
  }
}
